import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-dashboard',
    templateUrl: './simple-layout.component.html',
    styleUrls: ['./simple-leyout.component.css'],
    // template: '<router-outlet></router-outlet>',
})
export class SimpleLayout implements OnInit, OnDestroy {

    homologacao = !environment.production;

    ngOnInit(): void {
        // document.querySelector('body').classList.add('fundo-layout');
    }

    ngOnDestroy(): void {
        // document.querySelector('body').classList.remove('fundo-layout');
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/simple-layout/simple-layout.component.ts